const ServicioAsignacionValoresObjetos = {

  asignarAtributosObjeto(event, _this, toUpperCase) {
    let nombrePropiedad = event.target.name;
    let valorPropiedad = event.target.value;
    if (toUpperCase) {
      if (valorPropiedad)
        valorPropiedad = valorPropiedad.toUpperCase();
    }
    
    let nombreObjetoState = nombrePropiedad.split(".")[0];
    let nombreAtributoObjetoState = nombrePropiedad.split(".")[1];
    let objeto = _this.state[nombreObjetoState];
    objeto[nombreAtributoObjetoState] = valorPropiedad;
    _this.setState({ objeto });
  },
  esObjetoVacio(objeto) {     
    if (objeto === undefined)
      return true;
      
    if (objeto === null)
      return true;
      
    if (objeto.length > 0)      
      return false;
      
    if (objeto.length === 0)
      return true;
          
    if (objeto === true)
      return false;    
      
    if (Object.keys(objeto).length > 0)
      return false;
    

    if (JSON.stringify(objeto) === JSON.stringify({}))
      return true;
      
    for (var key in objeto) {
      if (hasOwnProperty.call(objeto, key))
        return false;              
    }
    if (typeof objeto === 'number')
      return false;
          
    if (JSON.stringify(objeto).length > 0)
        return false; 
    return true;
  }
}

export default ServicioAsignacionValoresObjetos;